import Vue from 'vue'
import {ptracAutocomplete, ptracGetEntities} from 'src/utilities/ptracApi'
import {make} from 'vuex-pathify'
import {byId, hydrateEdit, resetState, crudifyMutations, savePayload, updateResult} from 'src/utilities/vuex2'
import {OK} from 'http-status-codes'
import {objectById, sortBy, sortBySort} from 'src/utilities/utils'
import _ from 'lodash'

const initialState = {
  edit: {
    id: null,
    name: null,
    key: null,
    formFields: [],
    active: true,
    createdAt: null,
    createdBy: null,
    updatedAt: null,
    updatedBy: null
  },
  results: [],
  autocompleteResults: []
}

const state = Vue.util.extend({}, JSON.parse(JSON.stringify(initialState)))

const getters = make.getters(state)
getters.byId = byId
getters.savePayload = savePayload

const mutations = make.mutations(state)
crudifyMutations(mutations)
mutations.hydrateEdit = hydrateEdit
mutations.resetEdit = (state) => {
  state.edit = Vue.util.extend({}, JSON.parse(JSON.stringify(initialState.edit)))
}
mutations.reset = resetState
mutations.updateResult = (state, entity) => {
  updateResult(state, entity)

  const updatedFormFieldBlock = objectById(state.results, entity.id)
  updatedFormFieldBlock.formFields = sortBySort(updatedFormFieldBlock.formFields)
}
mutations.addResult = (state, entity) => {
  state.results.push(entity)
  state.results = sortBy(state.results, 'name')
}
mutations.addFormField = (state, formField) => {
  state.edit.formFields.push({
    formFieldLabel: formField.name,
    formFieldId: formField.id,
    sort: (state.edit.formFields.length * 100) + 100
  })
}
mutations.removeFormField = (state, formFieldId) => {
  state.edit.formFields = _.filter(state.edit.formFields, (formFieldMeta) => formFieldMeta.formFieldId !== formFieldId)
}
mutations.updateFormFieldsSort = (state, sortedFields) => {
  state.edit.formFields.forEach((formField) => {
    formField.sort = sortedFields[formField.formFieldLabel]
  })
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions: {
    async fetchAll({ state }) {
      const response = await ptracGetEntities('form-field-blocks/search/findAllByOrderByNameAsc')

      if (OK === response.status) {
        response.data.forEach((formFieldBlock) => {
          formFieldBlock.formFields = sortBySort(formFieldBlock.formFields)
        })

        state.results = response.data
      }

      return response
    },
    async fetchByFormFieldId({}, payload) {
      return await ptracGetEntities(`form-field-blocks/search/findByFormFieldId?formFieldId=${payload}`)
    },
    async fetchAutoCompleteResults({state}, query) {
      const response = await ptracAutocomplete('form-field-blocks/autocomplete?name=' + query)

      if (OK === response.status) {
        state.autocompleteResults = response.data
      }
      return response
    },
  },
}
